var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-wrap justify-center"},_vm._l((_vm.services),function(service){return _c('div',{staticClass:"w-full md:w-1/2 lg:w-1/3"},[_c('services-card-component',{attrs:{"service":service}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }